import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { TrackingElement } from '@sumup/collector';
import styled from '../../styles/styled';
import { focusVisible } from '../../styles/style-mixins';
import Hamburger from '../Hamburger';
import { SkeletonContainer } from '../Skeleton';
import { ProfileMenu } from './components/ProfileMenu';
import { UtilityLinks } from './components/UtilityLinks';
import { TRACKING_ELEMENTS } from './constants';
const CONTENT_HEIGHT = '56px';
export const TOP_NAVIGATION_HEIGHT = '57px'; /* content height + border-bottom */
const headerStyles = ({ theme }) => css `
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: ${TOP_NAVIGATION_HEIGHT};
  background-color: ${theme.colors.bodyBg};
  border-bottom: ${theme.borderWidth.kilo} solid ${theme.colors.n300};

  ${theme.mq.giga} {
    position: sticky;
    top: 0;
    /* The +1 is necessary to ensure that the primary navigation doesn't */
    /* overlap the top navigation on hover. */
    z-index: ${theme.zIndex.navigation + 1};
  }
`;
const Header = styled.header(headerStyles);
const hamburgerStyles = (theme) => css `
  padding: ${theme.spacings.mega};
  ${focusVisible('inset')(theme)};

  border-radius: 0;
  /* The !important below is necessary to override the default hover styles. */
  border-right: ${theme.borderWidth.kilo} solid ${theme.colors.n300} !important;

  ${theme.mq.giga} {
    display: none;
  }
`;
const logoStyles = ({ theme }) => css `
  height: ${CONTENT_HEIGHT};

  > * {
    display: block;
    height: inherit;
    line-height: 0;
    padding: ${theme.spacings.mega};
  }

  a,
  button {
    ${focusVisible('inset')(theme)};
  }

  svg {
    color: ${theme.colors.black};
    height: ${theme.iconSizes.mega};
  }
`;
const Logo = styled.div(logoStyles);
const wrapperStyles = css `
  display: flex;
  align-items: stretch;
  height: 100%;
`;
export function TopNavigation({ logo, user, profileMenu, links, hamburger, isLoading, ...props }) {
    return (_jsx(TrackingElement, { name: TRACKING_ELEMENTS.TOP_NAVIGATION, children: _jsxs(Header, { role: "banner", ...props, children: [_jsxs("div", { css: wrapperStyles, children: [hamburger && (_jsx(SkeletonContainer, { isLoading: Boolean(isLoading), children: _jsx(Hamburger, { ...hamburger, css: hamburgerStyles }, void 0) }, void 0)), _jsx(Logo, { children: logo }, void 0)] }, void 0), _jsxs(SkeletonContainer, { css: wrapperStyles, isLoading: Boolean(isLoading), children: [links && _jsx(UtilityLinks, { links: links }, void 0), _jsx(ProfileMenu, { ...profileMenu, user: user }, void 0)] }, void 0)] }, void 0) }, void 0));
}
